// src/ui/base/tooltip.tsx
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { withDefaults } from "../utils/withDefaults.mjs";
import { jsx } from "react/jsx-runtime";
var Tooltip = (props) => {
  return /* @__PURE__ */ jsx(TooltipPrimitive.Provider, { children: /* @__PURE__ */ jsx(TooltipPrimitive.Root, { ...props }) });
};
Tooltip.displayName = "Tooltip";
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = withDefaults(TooltipPrimitive.Content, {
  sideOffset: 4,
  className: "aui-tooltip-content"
});
TooltipContent.displayName = "TooltipContent";
export {
  Tooltip,
  TooltipContent,
  TooltipTrigger
};
//# sourceMappingURL=tooltip.mjs.map